import type { Editor } from "@tiptap/core/dist";
import { defineStore } from "pinia";
import { instance } from "./index";

const store = defineStore({
  id: "editor",
  state: () => ({
    editor: null as Editor | null,
    content: null as string | null,
  }),
  getters: {
    getEditor: (state) => state.editor,
    getContent: (state) => state.content,
  },
  actions: {
    setEditor(value: Editor | null) {
      this.editor = value;
    },
    setContent(value: string | null) {
      this.content = value;
    },
  },
});

export const useEditorStore = store(instance);
